import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
//import ButtonGroup from "@material-ui/core/ButtonGroup";

// Create a theme to make a disabled button without "disabled" look
// no longer needed as I have customized <StyledButton />
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

// 2 different things happening here
// 1) create a theme to Modify disabled buttons (no longer needed)
const theme = createMuiTheme({
  palette: {
    action: {
      disabledBackground: "#edf2f6",
      disabled: "black", // text color
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

// 2) Create a customized Styled <Button /> Component
const StyledButton = withStyles({
  root: {
    cursor: "default", // make sure cursor doesnt change to clickable event
  },
  label: {
    textTransform: "none",
    fontFamily: "Arial",
    fontWeight: "500",
    // cursor: "default",
  },
})(Button);

export default function ContainedButtons({ children }) {
  const classes = useStyles();

  return (
    <>
      {/* 
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
    */}

      {/* use disabled button theme, no disabled buttons so doing nothing 
      <StyledButton
        size="small"
        variant="outlined"
        text={{ textTransform: "none" }}
      >
        {children}
      </StyledButton>
      {/* 
      </ThemeProvider>
    </div>
      */}
      <Button variant="contained" color="#278ccf" size="small">
        {children}
      </Button>
    </>
  );
}
